import React from 'react';
import { useCurrentFrame, interpolate } from 'remotion';

interface SubLine {
  text: string;
  from: number;
  to: number;
}

interface SyncedSubtitlesProps {
  lines: SubLine[];
}

/**
 * Muestra subtítulos sincronizados al frame actual.
 * Cada línea tiene from/to en frames relativos a la escena.
 */
export const SyncedSubtitles: React.FC<SyncedSubtitlesProps> = ({ lines }) => {
  const frame = useCurrentFrame();

  // Encontrar la línea activa
  const activeLine = lines.find((l) => frame >= l.from && frame <= l.to);
  if (!activeLine) return null;

  const localFrame = frame - activeLine.from;
  const remainingFrames = activeLine.to - frame;

  const fadeIn = interpolate(localFrame, [0, 12], [0, 1], { extrapolateRight: 'clamp' });
  const fadeOut = interpolate(remainingFrames, [0, 12], [0, 1], { extrapolateRight: 'clamp' });
  const y = interpolate(localFrame, [0, 12], [8, 0], { extrapolateRight: 'clamp' });

  return (
    <div
      style={{
        position: 'absolute',
        bottom: 70,
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'center',
        zIndex: 50,
        opacity: fadeIn * fadeOut,
        transform: `translateY(${y}px)`,
      }}
    >
      <div
        style={{
          background: '#FFFFFFDD',
          backdropFilter: 'blur(12px)',
          borderRadius: 12,
          padding: '14px 36px',
          border: '1px solid #E2E8F0',
          maxWidth: '80%',
          boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
        }}
      >
        <div
          style={{
            fontSize: 22,
            fontWeight: 400,
            color: '#1E293B',
            textAlign: 'center',
            fontFamily: 'Inter, system-ui, sans-serif',
            lineHeight: 1.5,
            letterSpacing: 0.3,
          }}
        >
          {activeLine.text}
        </div>
      </div>
    </div>
  );
};
